export const state = () => ({
  loading: false,
  // authenticated: false,
  user: false,
  token: '',
  url: process.env.GALAXY_BASE_URL
})
export const getters = {
  loading(state) {
    return state.loading
  },
  authenticated(state) {
    return Boolean(state.token && state.user)
  },
  user(state) {
    return state.user
  },
  token(state) {
    return state.token
  }
}
export const mutations = {
  setLoading(state, { data }) {
    state.loading = data
  },
  setToken(state, { token }) {
    state.token = token
  },
  setUser(state, { user }) {
    if (user) {
      const { uid, email, emailVerified } = user
      state.user = { uid, email, emailVerified }
    } else {
      state.user = null
    }
  }
}
export const actions = {
  async createCustomToken({ commit }, { uid }) {
    commit('setLoading', { data: true })
    return await this.$axios
      .get(`/api/firebase/token/${uid}`, { withCredentials: true })
      .then((res) => {
        commit('setToken', { token: res.data })
        commit('setLoading', { data: false })
        return res
      })
      .catch((err) => {
        console.error(err)
        commit('setLoading', { data: false })
        commit('setToken', { token: '' })
        return err
      })
  }
}
